var countryName = document.getElementById("countryName");

function setCountryTooltip() {
    let findADealer = document.getElementById("findADealer");
    findADealer.addEventListener("mousemove",
        function(e) {
            var left = (e.clientX) + "px";
            var top = (e.clientY + 35) + "px";

            countryName.style.left = left;
            countryName.style.top = top;
        });
}

function showCountryTooltip() {
    countryName.style.visibility = "visible";
}

function hideCountryTooltip() {
    countryName.style.visibility = "hidden";
}

function setCountryTooltipText(text) {
    countryName.textContent = text;
}

export { setCountryTooltip, showCountryTooltip, hideCountryTooltip, setCountryTooltipText};